import { Injector } from "@angular/core";

export const appToolingInitializerFactory = (injector: Injector) => () =>
  initializeApp(injector);

async function initializeApp(injector: Injector): Promise<any> {}
